import { Row, Col, Divider, Tag } from "antd";
import {
  DashboardOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import "./cartop.css";

import { FormattedMessage, useIntl } from "react-intl";
import useIsDesktop from "../../utils/hooks/useIsDesktop";
import Typography from "../Typography";
import { COLORS } from "../../constants/Colors";
import _ from "lodash";

const ActiveQueue = (props) => {
  const { data, type } = props;
  const isDesktop = useIsDesktop();
  const colQueue = 12;
  const colQueueInside = isDesktop ? 8 : 12;
  const colQueueInsideMiddle = isDesktop ? 8 : 12;
  const colQueueInsideEnd = isDesktop ? 8 : 24;
  const paddingCol = isDesktop ? "p-2" : "p-2";
  const classNameCol = isDesktop ? "column-queue p-2 " : "column-queue p-2";
  const classNameColEnd = isDesktop
    ? "column-queue-white p-2 "
    : "column-queue-white p-2 mt-2";
  console.log("loCOAOCOACO", localStorage);

  const mocData = [
    {
      queueNo: "0011",
      status: "กำลังส่ง",
      vanNo: "001 01-0001",
      parkNo: "A0001",
      parkName: "แผงจอห์น",
      list: "5",
      statusQueue: "รอแล้ว 25 นาที",
    },
    {
      queueNo: "0012",
      status: "กำลังส่ง",
      vanNo: "001 01-0001",
      parkNo: "A0001",
      parkName: "แผงจอห์น",
      list: "5",
      statusQueue: "รอแล้ว 25 นาที",
    },
    {
      queueNo: "0013",
      status: "กำลังส่ง",
      vanNo: "001 01-0001",
      parkNo: "A0001",
      parkName: "แผงจอห์น",
      list: "5",
      statusQueue: "รอแล้ว 25 นาที",
    },
    {
      queueNo: "0014",
      status: "กำลังส่ง",
      vanNo: "001 01-0001",
      parkNo: "A0001",
      parkName: "แผงจอห์น",
      list: "5",
      statusQueue: "รอแล้ว 25 นาที",
    },
    {
      queueNo: "0015",
      status: "กำลังส่ง",
      vanNo: "001 01-0001",
      parkNo: "A0001",
      parkName: "แผงจอห์น",
      list: "5",
      statusQueue: "รอแล้ว 25 นาที",
    },
  ];

  const queueContent = (data) => {
    console.log("DLLOL", data);

    const style = {
      background: "#0092ff",
      padding: "8px 0",
    };

    return (
      <div className="w-100" style={{ padding: "8px 16px" }}>
        <Row style={{ marginTop: "15px" }}>
          <Col span={colQueue}>
            <Tag
              className="tag-queue-left"
              color={COLORS.GreenBrown}
              style={{ width: "156px" }}
            >
              <Row>
                <Col span={colQueue}>
                  <Typography
                    className="p-2"
                    isBold
                    color={COLORS.White}
                    size={"14px"}
                  >
                    <FormattedMessage id="QueueTag" defaultMessage="Queue" />
                  </Typography>
                </Col>
                <Col className="right-card-top" span={colQueue}>
                  <Typography
                    className="p-2"
                    isBold
                    color={COLORS.White}
                    size={"15px"}
                  >
                    {_.get(data, "queueNo") || "-"}
                  </Typography>
                </Col>
              </Row>
            </Tag>
          </Col>
          <Col className="right-tag-column" span={colQueue}>
            <Tag className="tag-queue-right" color={_.get(data, "statusColor")}>
              <Typography
                className="px-2 py-1"
                isBold
                color={COLORS.White}
                size={"14px"}
                textAlign={"center"}
              >
                {_.get(data, "status")}
              </Typography>
            </Tag>
          </Col>
        </Row>
        <Row
          gutter={8}
          style={{
            paddingTop: "16px",
            paddingBottom: "16px",
            borderBottom: " 1px solid #E5E5E5",
          }}
        >
          <Col className="gutter-row" span={colQueueInside}>
            <div className={classNameCol}>
              {" "}
              <Typography
                className={paddingCol}
                isBold
                color={COLORS.GreenBrown}
                size={"14px"}
              >
                <FormattedMessage
                  id="HomeParkingNo"
                  defaultMessage="ช่องจอด เลขตู้"
                />
              </Typography>
              <Typography
                className="p-2"
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  textOverflow: "ellipsis",
                  lineHeight: "1.0em",
                  maxHeight: "2.56em",
                }}
                color={COLORS.Dark}
                size={"15px"}
              >
                {_.get(data, "vanNo")}
              </Typography>
            </div>
          </Col>
          <Col className="gutter-row" span={colQueueInsideMiddle}>
            <div className={classNameCol}>
              {" "}
              <Typography
                className={paddingCol}
                isBold
                color={COLORS.GreenBrown}
                size={"14px"}
              >
                {_.get(data, "parkNo")}
              </Typography>
              <Typography
                className="p-2"
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  textOverflow: "ellipsis",
                  lineHeight: "1.0em",
                  maxHeight: "2.56em",
                }}
                color={COLORS.Dark}
                size={"15px"}
              >
                {_.get(data, "parkName")}
              </Typography>
            </div>
          </Col>
          <Col className="gutter-row" span={colQueueInsideEnd}>
            <div className={classNameColEnd}>
              <Typography
                className={paddingCol}
                isBold
                color={COLORS.GreenBrown}
                size={"14px"}
              >
                {_.get(data, "list")}{" "}
                <FormattedMessage
                  id="HomeParkingList"
                  defaultMessage="รายการ"
                />
              </Typography>

              <Typography className="p-2" color={COLORS.Dark} size={"15px"}>
                <FormattedMessage id="queueWaiting" defaultMessage="รอแล้ว" />{" "}
                {_.get(data, "statusQueue")}{" "}
                {/* <FormattedMessage id="queueMinute" defaultMessage="นาที" /> */}
              </Typography>
            </div>
          </Col>
        </Row>
        {/* <Divider className="mt-4" /> */}
      </div>
    );
  };

  return (
    <div
      style={{
        overflowY: isDesktop ? "auto" : undefined,
        height: isDesktop ? "calc(100vh - 342px)" : undefined,
      }}
    >
      {_.map(data, (i) => {
        return queueContent(i);
      })}
    </div>
  );
};

export default ActiveQueue;
